export default __webpack_public_path__ + "pdf/Hero.142d50b.pdf";